import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiMenu, FiCoffee, FiSun, FiStar, FiMapPin, FiClock, FiNavigation, FiFacebook, FiInstagram, FiMusic, FiArrowRight, FiShoppingBag, FiHeart, FiMail, FiPhone, FiGlobe, FiX, FiChevronUp } from 'react-icons/fi';
import { FaUtensils, FaLeaf, FaTrophy, FaWhatsapp } from 'react-icons/fa';
import { GiCoffeeCup, GiCroissant, GiKnifeFork } from 'react-icons/gi';
import logo from '../Assets/logometropole.png';
import metropolenuit from '../Assets/metropolenuit.png';

const Home = () => {
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [showScrollButton, setShowScrollButton] = useState(false);

  // Données des offres quotidiennes
  const dailyOffers = [
    {
      id: 1,
      name: "Café Signature",
      description: "Specialité Metropole : café riche et aromatique pour seulement 13 DH",
      price: "13 DH",
      originalPrice: "15 DH",
      tag: "Populaire",
      icon: <GiCoffeeCup className="text-7xl" />
    },
    {
      id: 2,
      name: "Jus d'Orange",
      description: "Jus d'orange frais seulement à 16 DH",
      price: "16 DH",
      originalPrice: "18 DH",
      tag: "Offre du jour",
      icon: <GiCroissant className="text-7xl" />
    },
    {
      id: 3,
      name: "Le Duo Parfait",
      description: "Jus d'orange avec croissant pour seulement 18 DH",
      price: "18 DH",
      originalPrice: "20.00 DH",
      tag: "Meilleur rapport",
      icon: <GiKnifeFork className="text-7xl" />
    }
  ];

  // Gestion du scroll pour le header
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setIsHeaderVisible(false);
      } else if (currentScrollY < lastScrollY) {
        setIsHeaderVisible(true);
      }
      
      setShowScrollButton(currentScrollY > 300);
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const handleReservation = () => {
    window.location.href = 'tel:+212522820267';
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header - Style marron et blanc */}
      <header 
        className={`bg-white shadow-md sticky top-0 z-50 border-b border-[#D4A574] transition-all duration-500 ${
          isHeaderVisible ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'
        }`}
      >
        <div className="container mx-auto px-4 py-3">
          <div className="flex justify-between items-center">
            <Link to="/" className="flex items-center group">
              <img 
                src={logo} 
                alt="Espace Metropole" 
                className="h-12 w-auto object-contain"
              />
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center space-x-6">
              <Link to="/carte" className="text-[#5C4033] hover:text-[#1B5E20] font-medium text-sm uppercase tracking-wider transition-colors">
                Notre Menu
              </Link>
              <a href="#offres" className="text-[#5C4033] hover:text-[#1B5E20] font-medium text-sm uppercase tracking-wider transition-colors">
                Offres
              </a>
              <a href="#contact" className="text-[#5C4033] hover:text-[#1B5E20] font-medium text-sm uppercase tracking-wider transition-colors">
                Localisation
              </a>
              <button 
                onClick={handleReservation}
                className="bg-[#5C4033] text-white px-5 py-2 rounded-full hover:bg-[#1B5E20] transition-all text-sm uppercase tracking-wider font-semibold flex items-center gap-2 shadow-md"
              >
                <FiHeart className="text-sm" />
                Réserver
              </button>
            </nav>

            {/* Mobile Menu Button */}
            <button 
              onClick={() => setShowMobileMenu(!showMobileMenu)}
              className="md:hidden p-2 rounded-lg hover:bg-[#F5E6D3]"
            >
              {showMobileMenu ? <FiX className="text-2xl text-[#5C4033]" /> : <FiMenu className="text-2xl text-[#5C4033]" />}
            </button>
          </div>

          {/* Mobile Navigation */}
          <div className={`md:hidden transition-all duration-300 overflow-hidden ${
            showMobileMenu ? 'max-h-96 opacity-100 mt-3' : 'max-h-0 opacity-0'
          }`}>
            <div className="flex flex-col space-y-2 pb-3">
              <Link to="/carte" className="text-[#5C4033] hover:text-[#1B5E20] py-2" onClick={() => setShowMobileMenu(false)}>
                Notre Menu
              </Link>
              <a href="#offres" className="text-[#5C4033] hover:text-[#1B5E20] py-2" onClick={() => setShowMobileMenu(false)}>
                Offres
              </a>
              <a href="#contact" className="text-[#5C4033] hover:text-[#1B5E20] py-2" onClick={() => setShowMobileMenu(false)}>
                Localisation
              </a>
              <button 
                onClick={() => {
                  handleReservation();
                  setShowMobileMenu(false);
                }}
                className="bg-[#5C4033] text-white px-5 py-2 rounded-full font-semibold flex items-center justify-center gap-2 text-sm"
              >
                <FiHeart />
                Réserver
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Section Hero */}
      <section className="relative h-[500px] flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-no-repeat animate-scale"
          style={{
            backgroundImage: `url(${metropolenuit})`,
            backgroundPosition: 'center 28%',
            filter: 'brightness(0.5)',
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
        <div className="relative z-10 text-center text-white px-4 animate-fadeInUp">
          <div className="inline-block mb-2">
            <div className="w-12 h-0.5 bg-[#A5D6A7] mx-auto mb-1"></div>
            <span className="text-[#A5D6A7] tracking-wider text-xs uppercase">Bienvenue chez</span>
          </div>
          <h1 className="text-5xl md:text-7xl font-bold mb-2 tracking-tight">Espace Metropole</h1>
          <p className="text-lg md:text-xl mb-6 font-light font-serif max-w-2xl mx-auto">Une expérience culinaire unique au cœur de Casablanca</p>
          <div className="flex gap-4 justify-center flex-wrap">
            <Link 
              to="/carte"
              className="inline-flex items-center gap-2 bg-[#5C4033] text-white px-8 py-3 rounded-full text-base font-semibold hover:bg-[#1B5E20] transition-all shadow-lg hover:shadow-xl transform hover:scale-105"
            >
              <FiShoppingBag />
              Découvrir notre carte
              <FiArrowRight />
            </Link>
          </div>
        </div>
      </section>

      {/* Section Offres Quotidiennes */}
      <section id="offres" className="py-16 px-4 bg-white">
        <div className="container mx-auto">
          <div className="text-center mb-10">
            <span className="text-[#5C4033] font-semibold uppercase tracking-wider text-xs">Découvrez nos</span>
            <h2 className="text-4xl md:text-5xl font-bold text-[#5C4033] mb-2 mt-1">Offres Quotidiennes</h2>
            <div className="w-16 h-0.5 bg-[#1B5E20] mx-auto mb-4"></div>
            <p className="text-[#8B6914] max-w-2xl mx-auto">Des créations exclusives chaque jour par notre équipe de chefs passionnés</p>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {dailyOffers.map((offer) => (
              <div 
                key={offer.id} 
                className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-500 transform hover:-translate-y-2 group cursor-pointer border border-[#F5E6D3]"
              >
                <div className="relative h-48 bg-gradient-to-br from-[#F5E6D3] to-[#EDD9C0] flex items-center justify-center overflow-hidden">
                  <div className="transform group-hover:scale-110 transition-transform duration-500 text-[#5C4033]">
                    {offer.icon}
                  </div>
                  <span className="absolute top-3 right-3 bg-[#1B5E20] text-white px-2 py-0.5 rounded-full text-xs font-semibold shadow-lg flex items-center gap-1">
                    <FiStar className="text-xs" />
                    {offer.tag}
                  </span>
                </div>
                <div className="p-5">
                  <h3 className="text-xl font-bold text-[#5C4033] mb-2 group-hover:text-[#1B5E20] transition-colors">
                    {offer.name}
                  </h3>
                  <p className="text-[#8B6914] text-sm mb-4">{offer.description}</p>
                  <div className="flex items-center justify-between border-t border-[#F5E6D3] pt-3">
                    <div>
                      <span className="text-2xl font-bold text-[#1B5E20]">{offer.price}</span>
                      <span className="text-[#C4A77D] line-through ml-2 text-sm">{offer.originalPrice}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-8">
            <Link 
              to="/carte"
              className="inline-flex items-center text-[#1B5E20] font-semibold hover:text-[#5C4033] transition-colors group"
            >
              Voir tout le menu
              <FiArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </section>

      {/* Section Caractéristiques */}
      <section className="py-16 px-4 bg-[#F9F6F0]">
        <div className="container mx-auto">
          <div className="text-center mb-10">
            <span className="text-[#5C4033] font-semibold uppercase tracking-wider text-xs">Pourquoi nous choisir</span>
            <h2 className="text-4xl md:text-5xl font-bold text-[#5C4033] mb-2 mt-1">Une expérience unique</h2>
            <div className="w-16 h-0.5 bg-[#1B5E20] mx-auto"></div>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {[
              { icon: <FaUtensils className="text-5xl" />, title: "Chefs Expérimentés", desc: "Notre équipe de chefs talentueux prépare chaque plat avec passion" },
              { icon: <FaLeaf className="text-5xl" />, title: "Produits Frais", desc: "Nous sélectionnons les meilleurs ingrédients locaux" },
              { icon: <FaTrophy className="text-5xl" />, title: "Service d'Exception", desc: "Une équipe dédiée à votre confort pour une expérience inoubliable" }
            ].map((item, index) => (
              <div key={index} className="text-center group p-6 rounded-xl bg-white hover:shadow-lg transition-all duration-500 border border-[#F5E6D3]">
                <div className="text-[#1B5E20] mb-4 transform group-hover:scale-110 transition-transform duration-500 flex justify-center">
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold text-[#5C4033] mb-2">{item.title}</h3>
                <p className="text-[#8B6914] text-sm">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section Map */}
      <section id="contact" className="py-16 px-4 bg-white">
        <div className="container mx-auto">
          <div className="text-center mb-8">
            <span className="text-[#5C4033] font-semibold uppercase tracking-wider text-xs">Visitez-nous</span>
            <h2 className="text-4xl md:text-5xl font-bold text-[#5C4033] mb-2 mt-1">Nous trouver</h2>
            <div className="w-16 h-0.5 bg-[#1B5E20] mx-auto"></div>
            <p className="text-[#8B6914] mt-3">Venez découvrir notre espace unique au cœur de Casablanca</p>
          </div>
          
          <div className="rounded-xl overflow-hidden shadow-lg transform hover:scale-[1.01] transition-all duration-500 border border-[#F5E6D3]">
            <iframe
              src="https://www.google.com/maps?q=Espace%20Metropole%20H9CP%2BRHC%2C%20Rue%20de%20Varsovie%2C%20Casablanca&output=embed"
              width="100%"
              height="400"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Notre emplacement"
              className="w-full"
            ></iframe>
          </div>
          
          <div className="mt-6 grid md:grid-cols-3 gap-4 max-w-3xl mx-auto">
            <div className="bg-white rounded-lg p-4 shadow-md hover:shadow-lg transition-all text-center group border border-[#F5E6D3]">
              <div className="flex justify-center mb-2 group-hover:scale-110 transition-transform">
                <FiMapPin className="text-2xl text-[#1B5E20]" />
              </div>
              <p className="font-semibold text-[#5C4033] text-sm">Adresse</p>
              <p className="text-[#8B6914] text-xs mt-1">Espace Metropole, Rue de Varsovie, Casablanca</p>
            </div>
            <div className="bg-white rounded-lg p-4 shadow-md hover:shadow-lg transition-all text-center group border border-[#F5E6D3]">
              <div className="flex justify-center mb-2 group-hover:scale-110 transition-transform">
                <FiClock className="text-2xl text-[#1B5E20]" />
              </div>
              <p className="font-semibold text-[#5C4033] text-sm">Horaires</p>
              <p className="text-[#8B6914] text-xs mt-1">Lundi - Dimanche : 07:00 - 23:00</p>
            </div>
            <div className="bg-white rounded-lg p-4 shadow-md hover:shadow-lg transition-all text-center group border border-[#F5E6D3]">
              <div className="flex justify-center mb-2 group-hover:scale-110 transition-transform">
                <FiNavigation className="text-2xl text-[#1B5E20]" />
              </div>
              <p className="font-semibold text-[#5C4033] text-sm">Parking</p>
              <p className="text-[#8B6914] text-xs mt-1">Parking gratuit disponible</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer - Style marron et blanc avec vert foncé */}
      <footer className="bg-[#5C4033] text-white py-10">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-6">
            <div className="text-center md:text-left">
              <div className="flex items-center justify-center md:justify-start mb-3">
                <div className="bg-white rounded-lg p-1.5 shadow-lg">
                  <img 
                    src={logo} 
                    alt="Logo" 
                    className="h-8 w-auto object-contain"
                  />
                </div>
              </div>
              <p className="text-[#D4C4A8] text-sm">
                L'élégance et le raffinement au cœur de Casablanca
              </p>
            </div>
            
            <div className="text-center">
              <h4 className="text-base font-semibold mb-3 text-[#A5D6A7]">Contact</h4>
              <ul className="space-y-2 text-sm">
                <li className="flex items-center justify-center gap-2 text-[#D4C4A8]">
                  <FiPhone className="text-[#A5D6A7] text-xs" />
                  <span>(+212) 522-820-267</span>
                </li>
                <li className="flex items-center justify-center gap-2 text-[#D4C4A8] text-xs">
                  <FiMail className="text-[#A5D6A7]" />
                  <span>contact@espace-metropole.ma</span>
                </li>
                <li className="flex items-center justify-center gap-2 text-[#D4C4A8] text-xs">
                  <FiGlobe className="text-[#A5D6A7]" />
                  <span>www.espace-metropole.ma</span>
                </li>
              </ul>
            </div>
            
            <div className="text-center md:text-right">
              <h4 className="text-base font-semibold mb-3 text-[#A5D6A7]">Suivez-nous</h4>
              <div className="flex justify-center md:justify-end space-x-3">
                <a href="#" className="w-8 h-8 bg-[#7A5C48] rounded-full flex items-center justify-center hover:bg-[#1B5E20] transition-all">
                  <FiFacebook className="text-sm" />
                </a>
                <a href="#" className="w-8 h-8 bg-[#7A5C48] rounded-full flex items-center justify-center hover:bg-[#1B5E20] transition-all">
                  <FiInstagram className="text-sm" />
                </a>
                <a href="#" className="w-8 h-8 bg-[#7A5C48] rounded-full flex items-center justify-center hover:bg-[#1B5E20] transition-all">
                  <FiMusic className="text-sm" />
                </a>
                <a href="#" className="w-8 h-8 bg-[#7A5C48] rounded-full flex items-center justify-center hover:bg-[#1B5E20] transition-all">
                  <FaWhatsapp className="text-sm" />
                </a>
              </div>
            </div>
          </div>
          
          <div className="border-t border-[#7A5C48] mt-8 pt-6 text-center text-[#C4A77D] text-xs">
            <p>&copy; 2026 Espace Metropole. Tous droits réservés.</p>
          </div>
        </div>
      </footer>

      {/* Bouton Scroll to Top */}
      <button
        onClick={scrollToTop}
        className={`fixed bottom-6 right-4 md:hidden bg-[#1B5E20] text-white p-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 z-40 ${
          showScrollButton ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'
        }`}
        aria-label="Retour en haut"
      >
        <FiChevronUp className="text-xl" />
      </button>

      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes scale {
          from {
            transform: scale(1);
          }
          to {
            transform: scale(1.05);
          }
        }
        .animate-fadeInUp {
          animation: fadeInUp 1s ease-out;
        }
        .animate-scale {
          animation: scale 20s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default Home;